module.exports = ".label-input {\n  display: block;\n  margin-bottom: 10px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #7b7b7b; }\n\n.form-input {\n  width: 100%;\n  border: 1px solid #d6d6d6; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/formulario/input-text/input-text.component.scss
// module id = ./src/app/components/formulario/input-text/input-text.component.scss
// module chunks = main